import styled from 'styled-components'
import { getCssBackgroundFromColorString } from '../../../../utils/color-utils'
import ColorPicker from '../../../color-picker'
import DropdownComponent from '../../../dropdown'
import { Subtitle } from '../../../typography'
import { SourceEditorCaptionStyle } from '../../types'

const Dropdown = styled(DropdownComponent)`
    flex-shrink: 0;
`

const ColorOptions = styled.div`
    width: 230px;
`

type Props = {
    captionStyle: SourceEditorCaptionStyle
    setCaptionStyle: (style: SourceEditorCaptionStyle) => void
}

const CreationSourceEditorCaptionColorDropdown = ({ captionStyle, setCaptionStyle }: Props) => {
    const { color: currentColor } = captionStyle

    const onColorChange = (color: string) => {
        setCaptionStyle({
            ...captionStyle,
            color,
        })
    }

    return (
        <Dropdown
            {...{
                preview: <div style={{ background: getCssBackgroundFromColorString(currentColor) }} />,
            }}
        >
            <ColorOptions>
                <Subtitle>Fill Options</Subtitle>
                <ColorPicker
                    {...{
                        defaultColor: currentColor,
                        showInput: true,
                        onColorChange,
                    }}
                />
            </ColorOptions>
        </Dropdown>
    )
}

export default CreationSourceEditorCaptionColorDropdown
